import { Typography } from "@mui/material";
import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";

const LeadsPage = (): ReactNode => {
    return (
        <>
            <Typography variant="h4" mb={2}>
                All Leads
            </Typography>

            <Typography variant="h4" mb={2}>
                ToDo: Build Leads
            </Typography>

            {/*<MrtPeopleTable/>*/}
            <Outlet />
        </>
    );
};

export default LeadsPage;
